import {icon1,icon2,icon3,report,report1,hetongJ1,hetongW1,hetongW2,hetongG1,hetongG2,hetongS1,hetongS2,hetongJ2} from './commonImg';

const detailFa1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/fA/details1.png";
const detailFa2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/fA/details2.png";
const detailFa3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/fA/details3.png";
const detailFa4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/fA/details4.png";
const detailFa5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/fA/details5.png";

const fuAnBanner1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner1.jpg";
const fuAnBanner2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner1.png";
const fuAnBanner3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner2.jpg";
const fuAnBanner4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner2.png";
const fuAnBanner5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner3.jpg";
const fA_logo = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fA_logo.jpg";
const faQ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faQ1.png";
const faQ2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faQ2.png";
const faQ3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faQ3.png";
const faQ4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faQ4.png";
const faQ5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faQ5.png";
const faQ6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faQ6.png";

const faC1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC1.png";
const faC2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC2.jpg";
const faC3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC3.jpg";
const faC4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC4.png";
const faC5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC5.jpg";
const faC6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC6.jpg";
const faC7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC7.jpg";
const faC8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/faC8.jpg";

const fa1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa1.png";
const fa2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa2.png";
const fa3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa3.png";
const fa4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa4.png";
const fa5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa5.png";
const fa6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa6.png";
const fa7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa7.png";
const fa8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/fa8.png";

const hetongFa1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongFa1.png";
const hetongFa2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongFa2.png";
const hetongFa3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetongFa3.png";

const fuAnBanner11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner11.jpg";
const fuAnBanner12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner12.jpg";
const fuAnBanner13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner13.jpg";
const fuAnBanner14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner14.jpg";
const fuAnBanner15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner15.jpg";
const fuAnBanner16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner16.jpg";
const fuAnBanner17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner17.jpg";
const fuAnBanner18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/fuAnBanner18.jpg";

export default {
    homeData: {
		herderBanner: [fuAnBanner11, fuAnBanner12, fuAnBanner13, fuAnBanner14, fuAnBanner15, fuAnBanner16,fuAnBanner17,fuAnBanner18],
		//企业logo
		// logo: 'http://firetopscomm.com/upload/image/20210329/1617010469288319.png',
		logo: fA_logo,
		//企业Vr背景
		vRlogo: fuAnBanner1,
		// 是否展示vr模块
		isShowVrModal: false,
		// vrurl
		vRurl: "",
		isShowVr: false,
		// 是否展示视频
		isVideo: true,
		// 视频封面图
		videoLogo: fuAnBanner4,
		// 视频地址
		videoUrl: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/fuan.mp4",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview:
			"陕西赋安门窗有限公司拥有钢质隔热防火门、钢木质隔热防火门、木质隔热防火门、木质隔热套装防火门、钢质复合防火卷帘、特级无机复合防火卷帘、防火窗、耐火窗、防火防盗门、防盗门、学校门、医院门等系列产品，公司集生产、销售、服务为一体，依靠严格的经营管理，完善的质量保证体系，良好的售后服务体系使产品一直走在市场前列。公司奉行“诚信为根，质量为本”的服务宗旨，遵循“品质造就品牌“的发展思路，奉承“品牌兴企，品质兴企”、“管理兴企”三大举措不断提升自身的核心竞争力。至真至诚的赋安人愿意与各界朋友携手共进，共同发展，以大中国，大世界的超前目光，永立市场经济的潮头，昂首阔步走向更加辉煌的明天。企业始终坚持“以人为本”。以团结高效的工作热情，不断培养出高素质、高效率、高稳定的施工团队。精心设计，精心施工，精心服务广大新老客户，持续打造让您满意的门窗工程 。",
		//公司官网
		website: "http://www.fuanfhm.com/",
		operatingStatus: "正常在业",
		//经营品类
		categories:
			"建筑装饰工程，机电设备安装工程，安防工程、消防工程的设计、施工、安装。(依法须经批准的项目，经相关部门批准后方可开展经营活动)",
		//公司地址
		companyAddress: "陕西省三原县重化工业园冶金大道东段",
		site: "陕西省三原县",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "10000万人民币",
		//成立日期
		establishment: "2014-06-25",
		//经营品牌
		brand: "赋安",
		//主营产品
		mainProducts: "防火窗,钢质防火门,钢木质防火门,防火卷帘门,木质防火门",
		//企业名称
		headerTitle: "陕西赋安门窗有限公司",
		moreInfoName: "陕西赋安",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: "1.预付款 2.按工程进度付款3.按工程进度付款",
		//工厂地址
		factoryAddress: "陕西省三原县重化工业园冶金大道东段",
		//工厂人数
		factoryHeadcount: "200名",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 仓储工厂
		// 生产基地总面积
		// 单个基地年产量
		factoryHeadcount: "省市布局1-2个",
		factoryAddress: "15000平方米",
		annualOutputValue: "30000平方米",
		capacity: "50万平方米",

		//联系负责人
		person: "白文彬 先生 ",
		//联系电话
		contactNumber: "18391089199",
		//资质证书
		qualificationList: [
			{
				name: "安全生产许可",
				path: faQ1,
			},
			{
				name: "质量管理体系认证",
				path: faQ2,
			},
			{
				name: "环境管理体系认证",
				path: faQ3,
			},
			{
				name: "职业健康安全管理体系认证",
				path: faQ4,
			},
			{
				name: "营业执照",
				path: faQ5,
			},
			{
				name: "绿色环保产品",
				path: faQ6,
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "2018年度央视展播品牌",
				path: faC1,
			},
			{
				name: "诚信经营示范单位",
				path: faC2,
			},
			{
				name: "企业信用等级证书",
				path: faC3,
			},
			{
				name: "全国诚信经营示范单位",
				path: faC4,
			},
			{
				name: "质量服务诚信单位",
				path: faC5,
			},
			{
				name: "中国诚信企业家",
				path: faC6,
			},
			{
				name: "重合同，守信用单位",
				path: faC7,
			},
			{
				name: "重质量、守信用证",
				path: faC8,
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西建工控股集团有限公司",
				path: "https://image.qcc.com/auto/664f7cbaec87d79892a9d503e05c990a.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "中国建筑一局（集团）有限公司",
				path: "https://image.qcc.com/logo/57624e7473d5759fc091e6ac48f0062d.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "碧桂园控股有限公司",
				path: "https://image.qcc.com/logo/hbfe840644a7dc0471cf2bd5e1e9d5cb.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "中铁建设集团有限公司",
				path: "https://image.qcc.com/logo/a26d363487d4d6e2f37fe0e9044606b2.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "中国二冶集团",
				path: "https://image.qcc.com/logo/e53468beeb04317ef428dd75b68e2235.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "恒大地产集团有限公司",
				path: "https://image.qcc.com/logo/917720a16d08bdde171681983391aed0.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "华润置地有限公司",
				path: "https://image.qcc.com/logo/h40fca476c71c4dfde06599a476e0160.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 80,
				num: 80,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1127,
				num: 18,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "36亿+",
				num: 24,
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [
			{
				name: "陕西川百煜集成房屋有限公司",
				jumpParameter: "川百煜",
				site: "陕西省渭南市富平县庄里镇西上官村",
				path: "https://img.trustexporter.com/202112/23/083010562007719.png",
				capital: "人民币800万元",
				business:
					"建筑材料销售；集装箱制造；金属结构制造；五金产品零售；建筑装饰材料销售；卫生洁具销售；门窗销售；建筑防水卷材产品销售；集装箱销售；集装箱租赁服务",
			},
			{
				name: "浙江杭加泽通建筑节能新材料有限公司",
				jumpParameter: "杭加泽通",
				site: "浙江省杭州市富阳区渔山工业区",
				path: "https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=3218430523,254919849&fm=179&app=42&f=JPEG?w=300&h=300&s=4D261D72EB884CC85C5160D4000010B2",
				capital: "人民币60000万元元",
				business: "杭加alc板;ALC板材;增压加气混凝土板;AAC板;轻质隔墙板",
			},
		],
	},
	listData: {
		productList: [
			{ name: "钢质防火门", img: detailFa1 },
			{ name: "钢木质防火门", img: detailFa2 },
			{ name: "木质防火门", img: detailFa3 },
			{ name: "防火窗", img: detailFa4 },
			{ name: "防火卷帘门", img: detailFa5 },
		],
		aim: "多年专注防火门窗生产和销售",
		navList: [
			{
				name: "防火门",
				isShow: false,
				children: ["钢质防火门", "钢木质防火门", "木质防火门", "防火卷帘门"],
			},
			{
				name: "防火窗",
				isShow: false,
				children: ["防火窗"],
			},
		],
	},
	productDetailsData: {
		钢质防火门: {
			name: "钢质防火门",
			img: detailFa1,
			modelNumber: [
				{
					title: "暂无",
					img: detailFa1,
				},
			],
			price: "暂无",
			detailImgs: [detailFa1, detailFa2, detailFa3, detailFa4, detailFa5],
			modelNumberText: "暂无",
			brand: "赋安",
			describe:
				"钢质隔热防火门适用于各种高层、高级建筑。宾馆、饭店、医院、工业厂房、商业中心和娱乐场所等，适用于GB/T5824-2008建筑门图洞口尺寸系列，用于各种非标洞口也可以根据实际情况，单独进行设计和制作。",
			report: [report, report1],
		},
		钢木质防火门: {
			name: "钢木质防火门",
			img: detailFa2,
			modelNumber: [
				{
					title: "暂无",
					img: detailFa2,
				},
			],
			price: "暂无",
			detailImgs: [detailFa2, detailFa2, detailFa3, detailFa4, detailFa5],
			modelNumberText: "暂无",
			brand: "赋安",
			describe:
				"钢木质隔热防火门适用于各种高层、高级建筑、宾馆、饭店、医院、工业厂房、商业中心和娱乐场所等，适用于GB/T5824-2008建筑门窗洞口尺寸系列，用于各种非标洞口也可以根据实际情况，单独进行设计和制造。",
			report: [report, report1],
		},
		木质防火门: {
			name: "木质防火门",
			img: detailFa3,
			modelNumber: [
				{
					title: "暂无",
					img: detailFa3,
				},
			],
			price: "暂无",
			detailImgs: [detailFa3, detailFa2, detailFa3, detailFa4, detailFa5],
			modelNumberText: "暂无",
			brand: "赋安",
			describe:
				"木质隔热防火门适用于各种高层、高级建筑、宾馆、饭店、医院、工业厂房、商业中心和娱乐场所等，适用于GB5824-2008建筑门窗洞口尺寸系列，用于各种非标洞口也可以根据实际情况，单独进行设计和制造。",
			report: [report, report1],
		},
		防火窗: {
			name: "防火窗",
			img: detailFa4,
			modelNumber: [
				{
					title: "暂无",
					img: detailFa4,
				},
			],
			price: "暂无",
			detailImgs: [detailFa4, detailFa2, detailFa3, detailFa4, detailFa5],
			modelNumberText: "暂无",
			brand: "赋安",
			describe:
				"防火窗是指用冷乳薄钢板，窗扇骨架内填充不燃材料，并配以防火玻璃组成的能满足耐火稳定性，完整性和隔热性的特种窗。防火窗是建筑物防火分区分割的设施之一，通常用在防火墙上，对于减少火灾损失起着重要的重要。防火窗分固定、活动单扇、双扇多扇等各种规格。",
			report: [report, report1],
		},
		防火卷帘门: {
			name: "防火卷帘门",
			img: detailFa5,
			modelNumber: [
				{
					title: "暂无",
					img: detailFa5,
				},
			],
			price: "暂无",
			detailImgs: [detailFa5, detailFa2, detailFa3, detailFa1, detailFa5],
			modelNumberText: "暂无",
			brand: "赋安",
			describe:
				"该产品是现代建筑中最实用的一种消防产品，它具有防火、隔热、防烟、防盗多种功能，它广泛用于大型商场、图书馆、地下车库、宾馆、高层建筑、博物馆及地下人防工程。",
			report: [report, report1],
		},
	},
	contactListData: {
		list: [
			{
				name: "白文彬",
				position: "销售",
				id: "1",
				phoneNum: "18391089199",
				color: "#23B095 ",
				telephone: "",
				email: "3102896603@qq.com",
			},
			{
				name: "刘姗姗",
				position: "投标联系人",
				id: "1",
				phoneNum: "18792822229",
				color: "#23B095 ",
				telephone: "",
				email: " ",
			},
		],
	},
	caseData:	{
		list: [
			{
				name: "咸阳体育广场及五环公寓",
				id: 1,
				price: "229万元",
				time: "2019",
				site: "陕西省咸阳市",
				type: "体育广场",
				unit: "中国建筑一局（集团）有限公司",
				desc: "本项目结构形式为框架剪力墙结构 ，建筑面积约121000㎡，咸阳体育场总建筑面积76000㎡，地上局部一层，地下三层；五环公寓总建筑面积45000㎡，地上33层，地下2层",
				imgList: [{ title: "", path: fa1 }],
				proImgList: [{ title: "", path: fa1 }],
				contractList: [
					{ title: "", path: hetongFa1 },
					{ title: "", path: hetongFa2 },
					{ title: "", path: hetongFa3 },
				],
				product: "防火门、防火卷帘、防火窗",
			},
			{
				name: "泾渭新城三甲医院PPP建设工程",
				id: 2,
				price: "338.9万元",
				time: "2022",
				site: "陕西省西安市",
				type: "医院",
				unit: "中建五局第三建设有限公司",
				desc: "泾渭新城三甲医院项目位于泾渭新城泾勤路与渭中路十字东北角，项目由西安经开区管委会、中建丝路、中建五局投资建设。建设内容包括门诊医技楼、住院部、综合楼、报告厅、餐厅超市、地下停车场等。项目总投资约为23.4亿元，总占地面积约170亩，总建筑面积约28.7万平方米，其中地上建筑面积约15.5万平方米，地下建筑面积13.2万平方米，地上建筑高12层，地下建设三层。",
				imgList: [{ title: "", path: fa2 }],
				proImgList: [{ title: "", path: fa2 }],
				contractList: [
					{ title: "", path: hetongW1 },
					{ title: "", path: hetongW2 },
				],
				product: "防火门、防火卷帘、防火窗",
			},
			{
				name: "嘉元•观澜国际一期防火门项目",
				id: 3,
				price: "222.8万元",
				time: "2022",
				site: "甘肃省天水市",
				type: "住宅",
				unit: "嘉元置业有限公司",
				desc: "嘉元·观澜国际地处秦州新城核心腹地，毗邻规划中的天水轻轨三中站，坐拥多维路网便捷交通，快速畅享城市繁华配套，涵盖生活、娱乐、医疗、教育等全方位资源，满足一站式生活所需。依托生态藉河，纵览间赏自然风姿，俯仰间阅四季景致，居于此，鲜氧呼吸，悠享惬意时光，占地52000㎡，容积率3.5，总建面34.7万方，共14栋高层住宅，面积段87-119㎡，其中87㎡和99㎡为主力户型。 ",
				imgList: [{ title: "", path: fa3 }],
				proImgList: [{ title: "", path: fa3 }],
				contractList: [
					{ title: "", path: hetongG1 },
					{ title: "", path: hetongG2 },
				],
				product: "防火门",
			},
			{
				name: "周礼佳苑安居小区二期项目",
				id: 3,
				price: "500万",
				time: "2020",
				site: "陕西省咸阳市",
				type: "住宅",
				unit: "陕西建工第九建设集团有限公司",
				desc: "周礼佳苑安居小区二期项目选址在秦汉新城周陵新兴产业园规划范围内，位于天工一路以南，周康路以西，电缆公司以北，天汉大道以北区域。该项目总建筑面积约34万平方米。",
				imgList: [{ title: "", path: fa4 }],
				proImgList: [{ title: "", path: fa4 }],
				contractList: [
					{ title: "", path: hetongS1 },
					{ title: "", path: hetongS2 },
				],
				product: "防火门、防火卷帘、防火窗",
			},
			{
				name: "黄冈学府城",
				id: 3,
				price: "200万",
				time: "2020",
				site: "陕西省西安市",
				type: "住宅",
				unit: "陕西海格尔房地产开发有限公司",
				desc: "黄冈学府城位于西安市高陵西咸，由陕西全信实业有限公司建成，总建筑面积500000，总占地面积184666。",
				imgList: [{ title: "", path: fa5 }],
				proImgList: [{ title: "", path: fa5 }],
				contractList: [
					{ title: "", path: hetongJ1 },
					{ title: "", path: hetongJ2 },
				],
				product: "防火门、防火卷帘、防火窗",
			},
			{
				name: "西安交通大学附属创新港医院",
				id: 3,
				price: "约300万",
				time: "2021",
				site: "陕西省西安市",
				type: "医院",
				unit: "陕西盛超建筑工程有限公司",
				desc: "创新港医院位于西咸新区沣西新城“中国西部科技创新港”内，总占地面积194.97亩，整体规划包括3栋住院病房大楼、门诊大楼、医技大楼、综合实验大楼、国际医学健康中心等，总面积约为27.3万m2",
				imgList: [{ title: "", path: fa6 }],
				proImgList: [{ title: "", path: fa6 }],
				contractList: [
					{ title: "", path: hetongJ1 },
					{ title: "", path: hetongJ2 },
				],
				product: "防火门、防火卷帘、防火窗",
			},
			{
				name: "翎珑公馆",
				id: 3,
				price: "151万",
				time: "2019",
				site: "山西省运城市",
				type: "住宅",
				unit: "运城市东恒房地产开发有限公司",
				desc: "总建筑面积为108232.1m’，总建筑高度106.85m室内外高差0.15m，一层为公寓门厅和商铺，二层为商铺休息间，一、二建筑面积为8069.27㎡;三层为设备层，建筑面积为1689.35㎡;四-三十二层为公寓，面积为92610.79㎡;地下一层为汽车车库和设备用房，面积为5862.65m",
				imgList: [{ title: "", path: fa7 }],
				proImgList: [{ title: "", path: fa7 }],
				contractList: [
					{ title: "", path: hetongJ1 },
					{ title: "", path: hetongJ2 },
				],
				product: "防火门、防火卷帘、防火窗",
			},
			{
				name: "阳光渭水华庭",
				id: 3,
				price: "172万",
				time: "2021",
				site: "陕西省咸阳市",
				type: "住宅",
				unit: "咸阳新元房地产开发有限公司",
				desc: "阳光渭水华庭位于秦都区世纪大道西段，是由咸阳市房地产开发公司规划、开发的小区，2014年建成，规划面积50000平方米，建筑面积130000平方米。",
				imgList: [{ title: "", path: fa8 }],
				proImgList: [{ title: "", path: fa8 }],
				contractList: [
					{ title: "", path: hetongJ1 },
					{ title: "", path: hetongJ2 },
				],
				product: "防火门、耐火窗",
			},
		],
	},
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 2,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/cccf.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: 'CCCF消防认证',
				subtitle: "CCCF消防认证",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${6}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${6}.png`,
				// title: '央视展播品牌',
				subtitle: "央视展播品牌",
				isShow: true,
			},
		],
	},
	successfulBidderData: {
		info: [
			{
				name1: "2022-2024年度新虹联消防报警战略联采",
				name2: "2022-2024年度新虹联消防报警战略联采",
				name3: "物资采购",
				date: "2022/6/30",
			},
			{
				name1: "建工八建-天津分公司-石家庄龙湖天璞-普通灯具开关插座任务",
				name2: "石家庄龙湖天璞项目1标段总承包工程",
				name3: "物资采购",
				date: "2022/6/28",
			},
			{
				name1: "济南济齐路君逸府项目（应急电箱及灯具）",
				name2: "济南济齐路君逸府项目（应急电箱及灯具）询价项目",
				name3: "物资采购",
				date: "2021/12/2",
			},
			{
				name1: "天健地产集团2021-2023年度消防报警设备战略采购",
				name2: "天健地产集团2021-2023年度消防报警设备战略采购",
				name3: "物资采购",
				date: "2021/10/11",
			},
			{
				name1: "华西上海公司安装南京复地项目消防系统设备采购",
				name2: "华西上海公司安装南京复地项目消防系统设备采购",
				name3: "物资采购",
				date: "2021/8/25",
			},
			{
				name1: "天健地产集团2021-2023年度消防报警设备战略采购",
				name2: "天健地产集团2021-2023年度消防报警设备战略采购",
				name3: "物资采购",
				date: "2021/7/17",
			},
			{
				name1: "阜南安建-淮畔世家项目(消防报警设备)采购招标",
				name2: "阜南安建-淮畔世家项目",
				name3: "物资采购",
				date: "2019/4/24",
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建一建-三公司-星航未来·富阎新区品质阎良绿色宜居项目-防火门专业分包合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "星航未来·富阎新区品质阎良绿色宜居项目",
				"name3": "专业分包",
				"date": "2023年6月6日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "工程三部三分司陕西省崔家沟煤矿片区棚户区改造项目三标段防火门专业分包合同",
				"name4": "陕西建工集团股份有限公司工程三部",
				"name2": "陕西省崔家沟煤矿片区棚户区改造项目施工（三标段）",
				"name3": "专业分包",
				"date": "2023年6月6日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "工程三部三分司陕西省崔家沟煤矿片区棚户区改造项目施工一期防火门专业分包合同",
				"name4": "陕西建工集团股份有限公司工程三部",
				"name2": "陕西省崔家沟煤矿片区棚户区改造项目施工（三标段）",
				"name3": "专业分包",
				"date": "2023年6月6日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建一建-三公司-未来人工智能计算中心（二期)-防火门工程专业分包合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "未来人工智能计算中心",
				"name3": "专业分包",
				"date": "1900年1月0日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕西燃气产业研发与孵化基地项目防火门专业分包合同2023年4月22日",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "陕西燃气产业研发与孵化基地项目",
				"name3": "专业分包",
				"date": "2023年4月27日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建装饰+工程三部+足球中心+钢质门采购合同",
				"name4": "陕西建工装饰集团有限公司",
				"name2": "西安国际足球中心室内装饰装修项目",
				"name3": "物资采购",
				"date": "2023年5月15日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "第四工程公司-蓝田县灾后重建玉山镇安置区（一期）建设项目-CL-防火门合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "蓝田县灾后重建玉山镇安置区建设项目（东区）",
				"name3": "物资采购",
				"date": "2023年4月23日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "建筑工程专业分包工程",
				"name4": "陕西建工第十一建设集团有限公司",
				"name2": "沣西新城新沣和园项目施工一标段（DK-3、4、5）",
				"name3": "专业分包",
				"date": "2023年3月27日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "临潼宾馆项目 甲级钢质防火门材料",
				"name4": "陕西建工装饰集团有限公司",
				"name2": "临潼宾馆项目",
				"name3": "物资采购",
				"date": "1900年1月0日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "第一工程公司-蓝田县灾后重建玉山镇安置区（一期）建设项目 建设工程钢质防火门物资采购合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "蓝田县灾后重建玉山镇安置区建设项目(西区)",
				"name3": "物资采购",
				"date": "2023年2月7日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "火箭军工程大学综合楼工程防火门窗专业分包合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "火箭军工程大学综合楼工程",
				"name3": "专业分包",
				"date": "2023年1月3日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建一建集团-市政路桥公司-沣东新城2022年老旧小区提升改造项目-楼宇防盗门采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "沣东新城2022年老旧小区提升改造项目",
				"name3": "物资采购",
				"date": "2022年12月26日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "空港国际商务中心二期项目装修工程防火门材料采购合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "空港国际商务中心二期项目装修工程",
				"name3": "物资采购",
				"date": "2023年1月10日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "延安市人民医院改扩建项目防火门专业分包合同2022.11.25",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "延安市人民医院改扩建项目",
				"name3": "专业分包",
				"date": "2022年12月2日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "西电大土门13＃、14＃高层住宅楼项目防火门窗制作与安装专业分包合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西电大土门13#、14#高层住宅楼工程",
				"name3": "专业分包",
				"date": "2022年11月16日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "欧亚国际三期（商业）项目4号楼及其附楼及地下室防火门工程",
				"name4": "陕西建工第七建设集团有限公司",
				"name2": "欧亚国际三期（商业）工程",
				"name3": "专业分包",
				"date": "2022年10月10日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建一建-五公司-陕西数字医药产业园项目-挡烟垂壁防火门",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "陕西数字医药产业园项目",
				"name3": "专业分包",
				"date": "2022年9月20日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "雲玥府项目防火门采购",
				"name4": "陕西建工集团股份有限公司工程六部",
				"name2": "雲玥府项目施工总承包一标段",
				"name3": "物资采购",
				"date": "2022年9月20日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕五建三公司+团结安置项目+DK-2防火门专业分包合同",
				"name4": "陕西建工第五建设集团有限公司",
				"name2": "陕西建工第五建设集团有限公司三公司",
				"name3": "专业分包",
				"date": "2022年8月23日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕三建第三工程公司空港国际商务中心二期防火门专业分包2",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "空港国际商务中心二期项目",
				"name3": "专业分包",
				"date": "2022年9月26日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "欧亚国际三期（商业）项目3号楼防火门工程",
				"name4": "陕西建工第七建设集团有限公司",
				"name2": "欧亚国际三期（商业）工程",
				"name3": "专业分包",
				"date": "2022年7月12日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "欧亚国际三期（住宅）1-6#楼防火门合同",
				"name4": "陕西建工第七建设集团有限公司",
				"name2": "欧亚国际三期（住宅）项目",
				"name3": "专业分包",
				"date": "2022年7月11日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕西学前师范学院儿童产业协同创新中心项目EPC总承包防火门专业分包",
				"name4": "陕西古建园林建设集团有限公司",
				"name2": "陕西学前师范学院儿童产业协同创新中心项目EPC总承包",
				"name3": "专业分包",
				"date": "2022年7月5日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建安装一分司蒲城莱特光电项目防火门采购合同",
				"name4": "陕西建工安装集团有限公司",
				"name2": "蒲城莱特光电新材料有限公司蒲城生产基地项目",
				"name3": "物资采购",
				"date": "2022年6月24日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "八建二公司铜川市航天科技产业孵化园防火门、卷帘门、玻璃门制作安装合同",
				"name4": "陕西建工第八建设集团有限公司",
				"name2": "铜川市航天科技产业孵化园2#厂房",
				"name3": "专业分包",
				"date": "2022年1月7日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建机施（钢构）西咸新区北营学校工程一期防火门补充协议任务任务",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "西咸新区北营学校工程",
				"name3": "专业分包",
				"date": "2022年2月16日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建一建-十公司-西安市美术陶瓷有限公司棚户区改造项目DK-2地块安置楼工程-防火门窗合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "西安市美术陶瓷有限公司棚户区改造项目DK-2地块安置楼工程",
				"name3": "专业分包",
				"date": "2021年10月26日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "西安数字康养小镇项目一标段防火门专业分包合同",
				"name4": "陕西建工集团股份有限公司工程四部",
				"name2": "西安数字康养小镇项目总包工程一标段",
				"name3": "专业分包",
				"date": "2021年12月2日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "先河.瞰都防火门采购合同",
				"name4": "陕西建工第七建设集团有限公司",
				"name2": "先河.瞰都项目",
				"name3": "物资采购",
				"date": "2021年8月16日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "先河.瞰都项目防火门采购合同",
				"name4": "陕西建工第七建设集团有限公司",
				"name2": "先河.瞰都项目",
				"name3": "物资采购",
				"date": "2021年8月16日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "西仪102棚改二标段项目耐火窗，地弹门专业分包合同2021.8.12",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西仪集团有限公司102小区国有土地上棚户区改造项目",
				"name3": "专业分包",
				"date": "2021年8月13日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "临空智慧云港（一期）项目 防火门采购合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "临空智慧云港（一期）项目工程总承包-十公司",
				"name3": "物资采购",
				"date": "2021年7月1日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "第六工程公司-新筑新城二期（西区）第三批项目-ZY-防火门专业分包合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "新筑新城二期（西区）第三批项目",
				"name3": "专业分包",
				"date": "2021年6月21日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "第六工程公司-新筑新城二期（西区）第四批项目-ZY-防火门专业分包合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "新筑新城二期（西区）第四批项目",
				"name3": "专业分包",
				"date": "2021年6月21日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "防火门、防火卷帘门-兴平市汽车客运站项目(站务大楼及公交公司办公楼)任务",
				"name4": "陕西建工第七建设集团有限公司",
				"name2": "兴平市汽车客运站项目(站务大楼及公交公司办公楼)",
				"name3": "专业分包",
				"date": "2021年6月10日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建安装十公司-新航分布式能源项目-门窗采购合同",
				"name4": "陕西建工安装集团有限公司",
				"name2": "西安新航燃气能源有限公司西安航天基地一期天然气分布式能源项目（二期）施工",
				"name3": "物资采购",
				"date": "2021年5月12日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建机施（钢构）西咸新区北营学校工程 防火门任务",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "西咸新区北营学校工程",
				"name3": "专业分包",
				"date": "2021年4月12日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "马术项目防火门买卖合同-赋安",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西咸新区第十四届全国运动会（马术）比赛马术馆及配套工程",
				"name3": "物资采购",
				"date": "2021年4月6日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "空港国际商务中心二期项目装修工程PVC专业分包",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "空港国际商务中心二期项目装修工程",
				"name3": "专业分包",
				"date": "2021年1月29日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕三建第三工程公司山水馨居项目钢制防火门、防火卷帘及挡烟垂壁合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "山水馨居重大项目（三）",
				"name3": "专业分包",
				"date": "2021年2月2日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "渭城区渭城中学迁址新建项目二标段防火门、窗、防火卷帘专业分包2020.1.3任务合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "咸阳市渭城区渭城中学迁址新建项目",
				"name3": "专业分包",
				"date": "2021年1月18日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建一建-第六公司-陕西考古博物馆-防火门及防火卷帘",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "陕西考古博物馆项目",
				"name3": "专业分包",
				"date": "2020年12月12日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建五建八公司金旅南璟台二期项目防火门合同",
				"name4": "陕西建工第五建设集团有限公司",
				"name2": "金旅-南璟台项目二期",
				"name3": "专业分包",
				"date": "2020年6月12日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建机施（钢构）陕西黄陵二号煤矿机修二车间建设项目-防火门、彩钢夹芯门采购",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "陕西黄陵二号煤矿有限公司机修二车间建设项目厂房及辅房工程",
				"name3": "物资采购",
				"date": "2020年6月2日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕建机施（钢构）陕西黄陵二号煤矿机修二车间建设项目-塑钢窗",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "陕西黄陵二号煤矿有限公司机修二车间建设项目厂房及辅房工程",
				"name3": "专业分包",
				"date": "2020年5月29日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "东塬陶瓷产业园标准化厂房 防火门专业分包合同",
				"name4": "陕西建工第八建设集团有限公司",
				"name2": "东塬陶瓷产业园标准化厂房",
				"name3": "专业分包",
				"date": "2020年11月11日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "铜川南部汽配园标准化厂房项目工程防火卷帘门",
				"name4": "陕西建工第八建设集团有限公司",
				"name2": "铜川南部汽配园标准化厂房项目工程",
				"name3": "专业分包",
				"date": "2020年11月11日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "宝能项目钢制防火门买卖合同-赋安",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西安宝能新能源汽车产业园一期项目生产厂房及配套设施EPC工程",
				"name3": "物资采购",
				"date": "2020年9月23日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "买卖合同",
				"name4": "陕西建工第十一建设集团有限公司",
				"name2": "杨凌渭惠家园",
				"name3": "物资采购",
				"date": "2020年6月14日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "第一工程公司-西安中兴深蓝科技产业园（DK-2）一标段-ZY-防火门加工及安装合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "西安中兴深蓝科技产业园（DK-2）一标段",
				"name3": "专业分包",
				"date": "2020年8月7日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "中国中药（旬邑）项目防火门专业分包合同",
				"name4": "陕西建工第八建设集团有限公司",
				"name2": "中国中药陕西一方平康产业园（旬邑）项目",
				"name3": "专业分包",
				"date": "2020年5月28日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "渭城区渭城中学迁址新建项目一标段防火门、窗，防火卷帘工程专业分包2020.4.28任务合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "渭城区渭城中学迁址新建项目",
				"name3": "专业分包",
				"date": "2020年6月12日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "西安航天基地军民融合创新园B区西段防火门专业分包合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西安航天基地军民融合创新园项目B区西段",
				"name3": "专业分包",
				"date": "2020年5月30日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕三建第三工程公司空港国际商务二期项目防火门及防火卷帘门专业分包任务",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "空港国际商务中心二期项目",
				"name3": "专业分包",
				"date": "2020年5月27日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "金旅-南星台项目东区防火门窗专业分包",
				"name4": "陕西建工集团股份有限公司工程五部",
				"name2": "金旅-南星台1#6#7#8#、护坡及东区车库",
				"name3": "专业分包",
				"date": "2020年4月24日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "西安工程大学金花校区3#住宅楼项目防火门、防盗门采购合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西安工程大学金花校区3#号楼住宅工程",
				"name3": "物资采购",
				"date": "2020年1月18日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "第十工程公司-西片区集中供热工程（二期）燃气锅炉房1施工-ZY-防火门专业分包合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "西片区集中供热工程（二期）燃气锅炉房1施工",
				"name3": "专业分包",
				"date": "2019年12月19日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "铜川市体育馆防火门窗工程专业分包合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "铜川体育馆",
				"name3": "专业分包",
				"date": "2019年11月29日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "防火门专业分包合同",
				"name4": "陕西建工第九建设集团有限公司",
				"name2": "陕西建工第九建设集团有限公司二分司周礼佳苑安居小区二期项目",
				"name3": "专业分包",
				"date": "2019年8月8日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "赛峰栏杆变形缝补充协议",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "东航-赛峰飞机起落架深度维修基地项目施工总承包",
				"name3": "专业分包",
				"date": "2019年6月21日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "防火门专业分包",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西藏民族大学新校区建设工程1、2、3号宿舍楼及学生餐饮活动中心项目",
				"name3": "专业分包",
				"date": "2019年5月7日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "木门、防火门专业分包合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西藏民族大学新校区建设工程1、2、3号宿舍楼及学生餐饮活动中心项目",
				"name3": "专业分包",
				"date": "1900年1月0日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "木门",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西藏民族大学新校区建设工程1、2、3号宿舍楼及学生餐饮活动中心项目",
				"name3": "专业分包",
				"date": "1900年1月0日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "防火门、木门专业分包合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西藏民族大学新校区建设工程1、2、3号宿舍楼及学生餐饮活动中心项目",
				"name3": "专业分包",
				"date": "2019年1月14日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕西赋安门窗有限公司",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "延安机场迁建工程地下停车场项目",
				"name3": "专业分包",
				"date": "2018年5月23日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕西赋安门窗有限公司",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "延安机场迁建工程地下停车场项目",
				"name3": "专业分包",
				"date": "1900年1月0日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "陕西赋安门窗有限公司",
				"name4": "陕西建工机械施工集团有限公司",
				"name2": "延安机场迁建工程地下停车场项目",
				"name3": "专业分包",
				"date": "2018年5月23日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "采购防盗门",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "九项目部  旬邑县马栏镇金盆社区移民搬迁安置项目（自）",
				"name3": "物资采购",
				"date": "2018年9月26日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "曲江三中木门防火门补充协议",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西安曲江第三中学",
				"name3": "物资采购",
				"date": "2018年9月4日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "曲江三中木门防火门合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西安曲江第三中学",
				"name3": "物资采购",
				"date": "2018年7月16日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "赛峰栏杆变形缝",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "东航-赛峰飞机起落架深度维修基地项目施工总承包",
				"name3": "专业分包",
				"date": "2018年6月25日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "赛峰防火门（新）",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "东航-赛峰飞机起落架深度维修基地项目施工总承包",
				"name3": "专业分包",
				"date": "2018年6月14日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "冷链女儿墙盖板",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西咸空港国际冷链物流仓储转运中心（一期)施工总承包",
				"name3": "专业分包",
				"date": "2018年5月22日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "冷链栏杆",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西咸空港国际冷链物流仓储转运中心（一期)施工总承包",
				"name3": "专业分包",
				"date": "2018年5月18日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "冷链防火门",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西咸空港国际冷链物流仓储转运中心（一期)施工总承包",
				"name3": "专业分包",
				"date": "2018年4月27日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "冷链独立柱护角",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西咸空港国际冷链物流仓储转运中心（一期)施工总承包",
				"name3": "专业分包",
				"date": "2018年4月27日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "冷链变形缝",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西咸空港国际冷链物流仓储转运中心（一期)施工总承包",
				"name3": "专业分包",
				"date": "2018年3月20日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "关中西线游客服务中心-防火门专业分包",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "关中西线游客服务中心",
				"name3": "专业分包",
				"date": "2018年1月24日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "钢制防盗门",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "西咸空港国际冷链物流仓储转运中心（一期)施工总承包",
				"name3": "物资采购",
				"date": "2017年12月13日",
				"out": true
			},
			{
				"企业名称": "陕西赋安门窗有限公司",
				"name1": "三原部队项目反板提升板合同",
				"name4": "陕西建工安装集团有限公司",
				"name2": "中国人民解放军68092部队3661工程",
				"name3": "物资采购",
				"date": "2017年6月12日",
				"out": true
			}
		],
	},
	lawData: {
		info: [
			{
				caseName: "陕西赋安门窗有限公司、俱亚行买卖合同纠纷民事一审民事裁定书",
				reference: "（2023）陕0422民初1067号",
				cause: "买卖合同纠纷",
				identity: "申请执行人",
				caseType: "原告",
				date: "2023-04-28",
			},
			{
				caseName: "陕西赋安门窗有限公司、陕西汉中鸿昊置业有限公司合同纠纷民事一审民事裁定书",
				reference: "（2021）陕0703民初3596号",
				cause: "合同纠纷",
				identity: "申请执行人",
				caseType: "原告",
				date: "2021-12-30",
			},
		],
	},
	tipData: {
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立5年以上",
			},
		],
	}
}